import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchFosaMedicalItems, generateInvoice, getClaims} from "../../action";
import "../../styles/theme.scss";
import {useTranslation} from "react-i18next";
import {Button, Chip, Grid, Typography} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import TableN from "../../reusableComponents/components/generics/TableN";
import {clearClaimResp} from "../../store/actions/exampleAction";
import DialogBox from "../../reusableComponents/components/dialogs/DialogBox";
import {LoadingButton} from "../../reusableComponents/components/generics/LoadingButton";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
import CardHeading from "../CardHeading";
import Card from "../Card";
import {decodeId, formatDate, formatNumber} from "../../utils/helper";
import {INVOICE_URL} from "../../utils/constant";
import {claimChipColor, claimStatusMapping} from "../../utils/statusMap";

function MedicalItemsTable() {
  const SignInSuccess = useSelector((state) => state);
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [medicalItemsData, setMedicalItemsData] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState();

  const [startCursors, setStartCursors] = useState();

  let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];


  const loadData = useCallback(() => {
    let params = buildQueryParams({
      // filters: filter,
      filters: {},
      pageSize,
      beforeCursor: endCursors,
      afterCursor: startCursors,
    });
    if (
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]
    ) {
      dispatch(fetchFosaMedicalItems(healthData?.location?.parent?.uuid, params));
    }
  }, [
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0],
    page,
    pageSize,
  ]);

  useEffect(() => {
    if (
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]
    ) {
      loadData();
    }
  }, [
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0],
    page,
    pageSize,
  ]);

  const buildQueryParams = (state) => {
    let params = [];

    // Ensure state.filters exists before trying to access its properties
    if (state.filters) {
      params = Object.keys(state.filters)
        .filter((f) => !!state.filters[f]["filter"])
        .map((f) => state.filters[f]["filter"]);
    }

    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]) {
      params.push(
        `priceListId: "${SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.itemsPricelist?.uuid}"`
      );
    }

    return params;
  };

  useEffect(() => {
    if (SignInSuccess?.fosaReducer?.MedicalItemsTableData) {
      setMedicalItemsData(SignInSuccess?.fosaReducer?.MedicalItemsTableData);
      setPageInfo(
        SignInSuccess?.fosaReducer?.MedicalItemsTableDataPageInfo.totalCount
      );
      setStartCursors(
        SignInSuccess?.fosaReducer?.MedicalItemsTableDataPageInfo?.endCursor
      );
      setEndCursors(
        SignInSuccess?.fosaReducer?.MedicalItemsTableDataPageInfo?.startCursor
      );
    }
  }, [SignInSuccess]);

  const headers = () => {
    var h = [
      "Code",
      // t("Reference No."),
      "Nom",
      "Type",
      "Prix",
    ];

    return h;
  };

  const handleRowDoubleClick = (rowData) => {
    // navigate(`/fosa/claimForm/:id=${rowData.uuid}`);
  };

  const itemFormatters = () => {
    var row = [
      (item) =>
        !!item.code ? item.code : "",

      (item) =>
        !!item.name ? item.name : "",

      (item) => 
        !!item.type ? t(`medical.itemType.${item.type}`) : "medical.itemType.null",
      (item) => 
        !!item.price ? formatNumber(item.price) : "",
    ];

    return row;
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setEndCursors(null);
    setStartCursors(null);
    setPage(0); // Reset to the first page when changing page size
  };

  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };

  return (
    <Grid container>
      {/* <TableN/> */}
      <Grid item xs={12}>
        <Card>
          <CardHeading
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography variant="h6">Tableau des produits</Typography>
            </Grid>
            <Grid item>
            </Grid>
          </CardHeading>

          <TableN
            headers={headers()}
            itemFormatters={itemFormatters()}
            items={medicalItemsData ? medicalItemsData : []}
            //withSelection={"single"}
            withPagination={true}
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={pageInfo}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onDoubleClick={handleRowDoubleClick}
            // rowLocked={this.rowLocked}
          />
        </Card>
      </Grid>
    </Grid>
  );
}

export default MedicalItemsTable;
